module.exports = __webpack_public_path__ + "static/img/pk-pz-active.ee2f2dd5.png";